module.exports = __webpack_public_path__ + "static/media/view5.0be6e19d.jpg";